nsr.config(['$stateProvider', function($stateProvider) {
    // $stateProvider
    //     .state('admin-groundfloor-manage', {
    //         url: "/admin/groundfloor-manage",
    //         templateUrl: 'operator-panel/partials/groundfloor/manage.html',
    //         controller: 'AdminGroundfloorAccountController'
    //     });

    // $stateProvider
    //     .state('admin-groundfloor-new', {
    //         url: "/admin/groundfloor-manage/new",
    //         templateUrl: 'operator-panel/partials/groundfloor/new.html',
    //         controller: 'AdminGroundfloorAccountNewController'
    //     });

    $stateProvider
        .state('admin-groundfloor-manage',
            simpleState("/admin/groundfloor-manage", 'operator-panel/partials/groundfloor/manage.html', 'AdminGroundfloorAccountController')
                .subView('admin-groundfloor.edit', 'operator-panel/partials/groundfloor/account.html', 'AdminGroundfloorAddAccountController')
                .subView('admin-groundfloor.upload', 'operator-panel/partials/groundfloor/upload.html', 'AdminGroundfloorUploadController')
        );
}]);